module.exports = __webpack_public_path__ + "static/media/Ski_failure.3b257b36.mp4";